import "./Projects.scss";
export default function Item(props) {
  return (
    <>
      <div>
        <ul class="card-wrapper">
          <li class="card">
            <a href={props.live}>
              <img src={props.image} alt="image" />
              <h3>{props.name}</h3>
              <p>{props.description}</p>
            </a>
          </li>
        </ul>
      </div>
    </>
  );
}
